import { Color } from 'types';

export function hexToRgb(hex): Color {
    if (!hex) {
        return [0, 0, 0];
    }
    // Remove the '#' if it's present
    hex = hex.replace('#', '');

    // Parse the hex color into its red, green, and blue components
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Return the result as an RGB array
    return [r, g, b];
}
